import PropTypes from 'prop-types';
import { Box, List, Text } from 'grommet';

export const Legend = ({ values, ...rest }) => {
    return (
        <List
            data={values}
            border={false}
            pad={{ vertical: '2px', horizontal: 'none' }}
            {...rest}
        >
            {datum => (
                <Box direction="row" align="center" gap="xsmall" title={`${datum.label}: ${datum.value}`} style={{ minWidth: 0 }}>
                    <Box flex={false} background={datum.color} height="8px" width="8px" round />
                    <Text size="xsmall" truncate>{datum.label}</Text>
                    {datum.displayValue != null && <Text size="xsmall">{datum.displayValue}</Text>}
                </Box>
            )}
        </List>
    );
};

Legend.propTypes = {
    values: PropTypes.arrayOf(PropTypes.object),
};